import ActionTypes from '../ActionTypes';

export function setAuthData(obj) {
  return {
    type: ActionTypes.Auth.setAuthData,
    obj,
  };
}

export function logout() {
  return {
    type: ActionTypes.Auth.logout,
  }
}

export function login(token) {
  return {
    type: ActionTypes.Auth.login,
    token,
  }
}



// WEBPACK FOOTER //
// /src/store/actions/AuthActions.js